<script>
  import dayjs from 'dayjs'
  import localizedFormat from 'dayjs/plugin/localizedFormat'
  import Card from '../../../components/card.svelte'
  import DataTable from '../../../components/data_table.svelte'
  import StateChip from '../../../components/badges/state_chip.svelte'
  import { REVIEWED, UNREVIEWED } from '../../../components/badges/chip_maps.js'

  dayjs.extend(localizedFormat)

  // Each is { records, total_count, shown }: the newest rows plus the real total.
  let { received = { records: [], total_count: 0 }, filed = { records: [], total_count: 0 } } = $props()
</script>

{#snippet truncationNote(list)}
  {#if (list?.total_count ?? 0) > (list?.records?.length ?? 0)}
    <p class="text-xs text-base-content/60 mt-2">Showing latest {list.records.length} of {list.total_count}.</p>
  {/if}
{/snippet}

{#snippet reportTable(rows, otherLabel)}
  <DataTable items={rows} emptyMessage="None.">
    {#snippet header()}
      <tr>
        <th>{otherLabel}</th>
        <th>Reason</th>
        <th>Details</th>
        <th>Status</th>
        <th>Reviewed By</th>
        <th>Date</th>
      </tr>
    {/snippet}
    {#snippet row(report)}
      <tr>
        <td>
          {#if report.other_user}
            <a href={report.other_user.url} class="link link-hover">
              {report.other_user.name || report.other_user.id}
            </a>
          {:else}
            —
          {/if}
        </td>
        <td>{report.reason_label}</td>
        <td class="max-w-xs whitespace-normal">{report.details || '—'}</td>
        <td>
          {#if report.reviewed}
            <StateChip label="Reviewed" tone={REVIEWED} />
          {:else}
            <StateChip label="Pending" tone={UNREVIEWED} />
          {/if}
        </td>
        <td>
          {#if report.reviewed_by?.url}
            <a href={report.reviewed_by.url} class="link link-hover">{report.reviewed_by.name}</a>
          {:else}
            —
          {/if}
        </td>
        <td>{dayjs(report.created_at).format('ll')}</td>
      </tr>
    {/snippet}
  </DataTable>
{/snippet}

<Card title="Reports Received">
  {#snippet actions()}
    <span class="badge badge-ghost">{received.total_count}</span>
  {/snippet}
  {@render reportTable(received.records, 'Reporter')}
  {@render truncationNote(received)}
</Card>

<Card title="Reports Filed">
  {#snippet actions()}
    <span class="badge badge-ghost">{filed.total_count}</span>
  {/snippet}
  {@render reportTable(filed.records, 'Reported User')}
  {@render truncationNote(filed)}
</Card>
